import { render, staticRenderFns } from "./TemplateDdv.vue?vue&type=template&id=25d94130&lang=html&"
import script from "./TemplateDdv.vue?vue&type=script&lang=js&"
export * from "./TemplateDdv.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDdv.vue?vue&type=style&index=0&id=25d94130&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports